import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings } = FiIcons;

const PortalCustomization = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="p-8 bg-gray-50 min-h-full"
    >
      <div className="flex items-center space-x-4 mb-8">
        <div className="p-3 bg-purple-100 rounded-full">
          <SafeIcon icon={FiSettings} className="h-8 w-8 text-purple-600" />
        </div>
        <div>
          <h1 className="text-4xl font-bold text-gray-800">Portal Customization</h1>
          <p className="text-lg text-gray-500">Tailor the portal's appearance and functionality.</p>
        </div>
      </div>
      
      <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
        <h2 className="text-2xl font-semibold text-gray-700">Customization Tools Coming Soon</h2>
        <p className="mt-4 text-gray-500 max-w-2xl mx-auto">
          Personalize your portal to match your brand. Future options will include theme customization, layout adjustments, and feature toggling to create a unique experience for your users.
        </p>
        <div className="mt-8">
          <SafeIcon icon={FiSettings} className="h-24 w-24 text-gray-200 mx-auto" />
        </div>
      </div>
    </motion.div>
  );
};

export default PortalCustomization;